import Swal from 'sweetalert2';

export default function errorAlert(title, message) {
    // Display the title and message using SweetAlert
    Swal.fire({
        title: title,
        text: message,
        icon: 'error',
        timer: 5000, // Set the timer for auto-close
        showConfirmButton: false
    });
}